import { useEffect } from 'react'

// Обновляет CSS-переменную --tg-app-height под реальный viewport TG
function applyViewportHeight(tg) {
  const h = tg?.viewportStableHeight
  if (h && h > 0) {
    document.documentElement.style.setProperty('--tg-app-height', `${h}px`)
  } else {
    document.documentElement.style.setProperty('--tg-app-height', '100dvh')
  }
}

export function useTelegram() {
  const tg = window.Telegram?.WebApp

  useEffect(() => {
    if (!tg) return
    tg.ready()
    tg.expand()
    tg.setHeaderColor('#0A0A0A')
    tg.setBackgroundColor('#0A0A0A')
    tg.disableVerticalSwipes?.()
    tg.enableClosingConfirmation?.()

    // Устанавливаем высоту сразу и при каждом изменении viewport
    applyViewportHeight(tg)
    tg.onEvent?.('viewportChanged', () => applyViewportHeight(tg))

    return () => {
      tg.offEvent?.('viewportChanged', () => applyViewportHeight(tg))
    }
  }, [tg])

  return {
    tg,
    user: tg?.initDataUnsafe?.user,
    haptic: tg?.HapticFeedback,
  }
}
